import React, { Fragment } from "react";
import "./Lending.css";
import Background from "../assets/Back.png";
import { Card } from "react-bootstrap";
import { alpha, styled } from "@mui/material/styles";

import TopImage from "../assets/dao-2.png";

import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import MetamaskImg from "../assets/metamask.png";
import wallet from "../assets/wallet.png";
import "./home.css";

import { Link } from "react-router-dom";

import AgreementRoot from "./AgreementRoot";
import CryptoRoot from "./CryptoRoot";
import SubscriptionRoot from "./SubscriptionRoot";
import ProductRoot from "./ProductRoot";
import InvoicingRoot from "./InvoicingRoot";
import AnalyticsRoot from "./AnalyticsRoot";

export default function Lending() {
  const RootStyle = styled(Card)(({ theme }) => ({
    boxShadow: "none",
    border: "none",
    textAlign: "center",
    padding: theme.spacing(5, 5),
    color: theme.palette.primary.main,
  }));

  const IconWrapperStyle = styled("div")(({ theme }) => ({
    margin: "auto",
    display: "flex",
    borderRadius: "50%",
    alignItems: "center",
    width: theme.spacing(8),
    height: theme.spacing(8),
    justifyContent: "center",
    marginBottom: theme.spacing(3),
    color: theme.palette.primary.main,
    backgroundImage: `linear-gradient(135deg, ${alpha(
      theme.palette.primary.main,
      0
    )} 0%, ${alpha(theme.palette.primary.dark, 0.24)} 100%)`,
  }));
  return (
    <Fragment>
      <div>
        <div className="img-back">
          <img alt="" src={Background} />
        </div>
        <header></header>
        <div className="container section-margin">
          <div className="row">
            <div className="col-2">
              <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className="launchModel"
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                  timeout: 1000,
                }}
              >
                <div className="model-paper">
                  <h2 id="transition-modal-title">Welcome to FORX1</h2>
                  <p id="transition-modal-description" className="text-center">
                    react-transition-group animates me.
                  </p>
                  <div className="launch-model-margin">
                    <div className="model-metamask">
                      <img src={MetamaskImg} alt="" width="20" height="20" />
                      <p>MetaMask</p>
                    </div>
                    <div className="model-wallet border-none">
                      <img src={wallet} alt="" width="20" height="20" />
                      <p>Wallet Connect</p>
                    </div>
                  </div>
                  <div className="text-center">
                    <Link to="/inventory" className="enterBtn">
                      continue
                    </Link>
                  </div>
                </div>
              </Modal>
            </div>
            <div className="col-8 col-lg-8 col-md-8  ">
              <h1 className="home-header-text">
                Complete <span style={{ color: "#6EBF8B" }}>DAO Team</span>{" "}
                Managment Solution
              </h1>
              <p className="home-body-text">
                The Decentra Tool helps DAO manage their role based Team
                membership using NFTs, Payroll management, DAO Drive for
                document management and grant role based permissions to DAO
                members.
              </p>
              <div className="watch-video-button mr-2">
                <button className="enterBtn">Learn More</button>
              </div>
            </div>
            {/* <div className="col-12 col-lg-5 col-md-5 home-top-image">
              <img src={TopImage} alt="" height="auto" width="100%" />
            </div> */}
            <div className="col-2 col-lg-2 col-md-2  "></div>
          </div>
        </div>

        <div className="container-fluid bg-color-section-3 section-margin ">
          <div className="row">
            <div className="col-12 col-lg-6 text-center m-auto  ">
              <h1
                className="section-header-text mt-4 "
                style={{ fontSize: "36px", fontWeight: "bold" }}
              >
                The <span style={{ color: "#6EBF8B" }}>Decentra Tool </span>{" "}
                Covers
              </h1>
            </div>
          </div>
          <div className="container  mt-5 mb-5 ">
            {/* <div className="row">
            </div> */}
            <div className="row">
              <div className="col-12 col-lg-4 col-md-4 mt-4">
                <AgreementRoot />
              </div>

              <div className="col-12 col-lg-4 col-md-4 mt-4">
                <CryptoRoot />
              </div>

              <div className="col-12 col-lg-4 col-md-4 mt-4">
                <SubscriptionRoot />
              </div>

              <div className="col-12 col-lg-4 col-md-4 mt-4">
                <ProductRoot />
              </div>

              <div className="col-12 col-lg-4 col-md-4 mt-4">
                <InvoicingRoot />
              </div>

              <div className="col-12 col-lg-4 col-md-4 mt-4">
                <AnalyticsRoot />
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid  section-margin mb-5">
          <div className="row">
            <div className="col-12 col-lg-6 text-center m-auto  ">
              <h1
                className="section-header-text "
                style={{ marginBottom: "90px" }}
              >
                How does it work ?
              </h1>
            </div>
          </div>
          <div className="col-8 m-auto">
            <div className="row">
              <div className="col-12 col-lg-4 col-md-4">
                <p className="section-token">Create NFT Memberships</p>
              </div>
              <div className="col-12 col-lg-4 col-md-4">
                <p className="section-token"> Create Roles for members</p>
              </div>
              <div className="col-12 col-lg-4 col-md-4">
                <p className="section-token">Assign Access Permissions </p>
              </div>
              <div className="col-12 col-lg-4 col-md-4">
                <p className="section-token">Manage Payroll </p>
              </div>
              <div className="col-12 col-lg-4 col-md-4">
                <p className="section-token">DAO Drive - Doc management </p>
              </div>
              <div className="col-12 col-lg-4 col-md-4">
                <p className="section-token">
                  Whistleblower and Feedback report
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
